__webpack_require__.p = "https://ciudadabierta.conjurors.com/decidim-packs/";